import axios from "axios";
const jsonConfig = require("../../Config.json");

const otherMySkillsByProfileIdResponse = async (candidateId) => {
  let allResponse = {};
  try {
    const response = await axios.get(
      jsonConfig.apiUrl + "otherMySkillsByProfileId/" + candidateId,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = response;
    return Promise.resolve(allResponse)
  }
  catch (error) {
    console.log("errrrrr", error);
    return Promise.reject(error);
  }
}

export default otherMySkillsByProfileIdResponse;